import type { BillingEntityInput } from '@pulsify/shared/dto'
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { billingEntitiesApi } from '~/entities/billing-entity/api/billing-entities'
import { QueryKey, queryKey } from '~/shared/lib/query-keys'

export function useBillingEntities(businessId: string | null | undefined) {
  return useQuery({
    queryKey: queryKey(QueryKey.BILLING_ENTITIES, businessId),
    queryFn: () => billingEntitiesApi.list(businessId ?? ''),
    enabled: !!businessId,
    staleTime: 60_000,
  })
}

export function useCreateBillingEntity(businessId: string | null | undefined) {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (input: BillingEntityInput) => billingEntitiesApi.create(businessId ?? '', input),
    onSuccess: () =>
      queryClient.invalidateQueries({ queryKey: queryKey(QueryKey.BILLING_ENTITIES, businessId) }),
  })
}
